import DatasetTag from '$provider/lib/apis/models/DatasetTag';
import { SchemaType } from '../apis/models/SchemaType';
import { schemaData } from '$shared/lib/data/SchemaData';
import { VerificationData } from '$shared/lib/appData/VerificationData';

class Data {
  public get WorkHistoryType(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.WorkHistoryType) || {};
  }

  public get TrainingType(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.TrainingType) || {};
  }

  public get GraduateType(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.GraduateType) || {};
  }

  public get ProviderStatus(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.ProviderStatus) || {};
  }

  public get ProviderInfoType(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.ProviderInfoType) || {};
  }

  public get MonitoringInterval(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.MonitoringInterval) || {};
  }

  public get EntityType(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.EntityType) || {};
  }

  public get BoardSource(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.BoardCertificationType) || {};
  }

  public get BoardSourceValidation(): ObjectType<string> {
    return {
      [this.BoardSource.AmericanSpeechLanguageHearingAssociation]:
        'Provided board certification input is invalid. Please enter 8-digit ASHA Account Number'
    };
  }

  public get State(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.State) || {};
  }

  public get InsuranceCoverageType(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.InsuranceCoverageType) || {};
  }

  public get Dataset(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.DatasetType) || {};
  }

  public get Gender(): ObjectType<string> {
    return schemaData.getSchema(SchemaType.Gender) || {};
  }

  public get SanctionDataset(): string[] {
    return VerificationData.data?.getTypesByTag(DatasetTag.SanctionsExclusions) || [];
  }

  public get BoardDataset(): string[] {
    return VerificationData.data?.getTypesByTag(DatasetTag.BoardCertifications);
  }

  public get MedicaidDataset(): string[] {
    return VerificationData.data?.getTypesByTag(DatasetTag.MedicaidEnrollment);
  }

  public getBoardSourceLabel(type: string): string {
    return (
      schemaData
        .getSchemaList(SchemaType.BoardCertificationType)
        .find((item) => item.value === type)?.description || type
    );
  }

  public getSchemaLabel(schema: SchemaType, type: string): string {
    return (
      schemaData.getSchemaList(schema).find((item) => item.value === type)?.description || type
    );
  }

  public getStateLabel(state: string): string {
    return `${this.getSchemaLabel(SchemaType.State, state)} (${state})`;
  }
}

export const data = new Data();
